module.exports = __webpack_public_path__ + "static/media/card_background_1.7a018880.jpg";